import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate, Navigate } from 'react-router-dom'
import { useContext } from 'react'
import ClientContext from 'contexts/ClientContext'
import style from './InsuredPersonSelection.module.scss'
import CircleSmile from 'components/assets/icons/CircleSmile'
import SquareSmile from 'components/assets/icons/SquareSmile'
import Card from 'components/common/Card/Card'
import PageTitle from 'components/common/PageTitle/PageTitle'
import PageSubtitle from 'components/common/PageSubtitle/PageSubtitle'

const InsuredPersonSelection = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { state } = useLocation()
  const { contract } = state || {}
  const { color, colabelNeutralMid, colabelNeutralDark } = useContext(ClientContext)

  const onSelectInsuredPerson = isSomeoneElse => {
    navigate('../contacts', { state: { contract, step: 1, isSomeoneElse, fromClaim: true } })
  }

  return !contract
  ? <Navigate to={'/claims/new'} replace />
  : (
    <>
      <PageTitle text={t('claim:applySteps.insuredPerson.title')} />
      <PageSubtitle text={t('claim:applySteps.insuredPerson.subtitle')} />

      <div className={style.options}>
        <Card
          className={style.option}
          content={
            <div className={style['option-content']}>
              <CircleSmile styles={color && {fill: colabelNeutralMid}} />
              <p>{t('claim:applySteps.insuredPerson.you')}</p>
            </div>
          }
          inactive={contract.cancelation}
          isCentered
          onClick={() => onSelectInsuredPerson()}
        />
        <Card
          className={style.option}
          content={
            <div className={style['option-content']}>
              <SquareSmile styles={color && {fill: colabelNeutralMid}} />
              <p>{t('claim:applySteps.insuredPerson.someoneElse')}</p>
            </div>
          }
          inactive={contract.cancelation}
          isCentered
          onClick={() => onSelectInsuredPerson(true)}
        />
      </div>
    </>
  )
}

export default InsuredPersonSelection
